import React, { Component } from 'react'
import CircularProgress from 'material-ui/CircularProgress'

const Styles = {
  curtainStyle: {
    backgroundColor: 'rgba(0,0,0,0.1)',
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99999
  }
}

export default class CurtainWithProgress extends React.Component {
  render () {
    return this.props.show ? (
      <div style={Styles.curtainStyle}><CircularProgress size={100} thickness={8} /></div>
      ) : null
  }
}



// WEBPACK FOOTER //
// ./src/components/CurtainWithProgress.js